// Generated by CoffeeScript 1.12.4

/*
Require google token auth for an angular application
- IMPORTANT: make sure you load this module before any others that depend on it
- You can override this functionality by setting bypassAuth: true on a state
- Whenever you change state or send a request, the token will renew if about to expire (but not expired yet)

@example
angular.module 'app', [
  require('goodeggs-authentication-tokens/angular/require_auth')('opsEmployeesApi')
]
 */
var errorMessages, renewingToken;

errorMessages = require('../../shared/error_messages');

renewingToken = false;


/*
@param authIdentifierApp - the app used to identify the user token
@param options.allowNonEmployees - allow non-employees (who log in via OAuth instead of SAML); should only be used by Drive UI
 */

module.exports = function(authIdentifierApp, options) {
  if (authIdentifierApp == null) {
    authIdentifierApp = 'kale';
  }
  if (options == null) {
    options = {
      allowNonEmployees: false
    };
  }
  angular.module(__filename, ['ui.router', require('../auth')]).factory('tokenInterceptor', [
    '$q', '$injector', '$rootScope', function($q, $injector, $rootScope) {
      return {
        request: function(config) {
          var $state, Auth, ref;
          $state = $injector.get('$state');
          Auth = $injector.get('Auth');
          if (!$state.current.bypassAuth && !renewingToken && (((ref = $rootScope.credentials) != null ? ref.google : void 0) != null)) {
            renewingToken = true;
            Auth.renewToken('google', authIdentifierApp, $rootScope.credentials.google, options).then(function(googleAuth) {
              return $rootScope.credentials.google = googleAuth;
            })["finally"](function() {
              return renewingToken = false;
            });
          }
          return config;
        },
        responseError: function(originalResponse) {
          var $state, Auth, ref, ref1, validTokenExpired;
          $state = $injector.get('$state');
          Auth = $injector.get('Auth');
          validTokenExpired = (((ref = $rootScope.credentials) != null ? ref.google : void 0) != null) && originalResponse.status === 401 && typeof ((ref1 = originalResponse.data) != null ? ref1.message : void 0) === 'string' && originalResponse.data.message.indexOf(errorMessages.tokenIdentifyErrorPrefix) !== -1;
          if (!$state.current.bypassAuth && validTokenExpired) {
            Auth.identifyToken('google', authIdentifierApp, options);
          }
          return $q.reject(originalResponse);
        }
      };
    }
  ]).config([
    '$httpProvider', function($httpProvider) {
      return $httpProvider.interceptors.push('tokenInterceptor');
    }
  ]).run([
    'Auth', '$rootScope', '$state', function(Auth, $rootScope, $state) {
      var pendingLogin;
      if ($rootScope.credentials == null) {
        $rootScope.credentials = {};
      }
      pendingLogin = false;
      $rootScope.$on('$stateChangeStart', function(e, toState, toStateParams) {
        var ref;
        if (toState.bypassAuth || (((ref = $rootScope.credentials) != null ? ref.google : void 0) != null)) {
          return;
        }
        e.preventDefault();
        if (pendingLogin) {
          return;
        }
        e.pendingLogin = pendingLogin = true;
        return Auth.identifyToken('google', authIdentifierApp, options).then(function(googleAuth) {
          $rootScope.credentials.google = googleAuth;
          e.pendingLogin = pendingLogin = false;
          return $state.go(toState.name, toStateParams);
        });
      });
      return $rootScope.$on('$stateChangeStart', function(e, toState, toStateParams) {
        var ref;
        if (toState.bypassAuth || renewingToken || (((ref = $rootScope.credentials) != null ? ref.google : void 0) == null)) {
          return;
        }
        renewingToken = true;
        return Auth.renewToken('google', authIdentifierApp, $rootScope.credentials.google, options).then(function(googleAuth) {
          return $rootScope.credentials.google = googleAuth;
        })["finally"](function() {
          return renewingToken = false;
        });
      });
    }
  ]);
  return __filename;
};
